module.exports = __webpack_public_path__ + "static/doublo-design-2214bfd2e2042788d8eb26e39017e6b9.gif";